import React, { useState, useEffect, Fragment } from 'react'
import "./Institution.css"
import bannerImg from "../../assets/images/header-banner-img.png"
// import bannerImg from "../../assets/images/portail_bcc.jpg"
import Header from '../../components/Header/Header'
import { FiFilter } from "react-icons/fi"
import { ImMakeGroup } from "react-icons/im"
import { FaClipboardList } from "react-icons/fa"
import CustomDatatable from '../../components/CustomDatatable/CustomDatatable'
import Select from "react-select"
import { getCategoryProductFilterList, getInstitutionDetails, getInstitutionRate } from '../../services/http';
import { useParams } from 'react-router-dom'
import Loader from '../../components/Loader/Loader'

const Institution = () => {

    const [etablissements, setEtablissements] = useState([])
    const [etablissementSelected, setEtablissementSelected] = useState()
    const [categoriesProduit, setCategoriesProduit] = useState([])
    const [rate, setRate] = useState([])
    const [categorieProduitSelected, setCategorieProduitSelected] = useState({ value: "", label: "" })
    const [data, setData] = useState([])
    const [institution, setInstitution] = useState(null)

    const { id } = useParams()

    const [displayLoader, setDisplayLoader] = useState(true);

    const tableColumns = [
        { id: "1", label: "#" },
        { id: "2", label: "Produit" },
        { id: "5", label: "Taux Appliqué" },
        { id: "6", label: "Catégorie de produit" }
    ]

    useEffect(() => {
        loadCategoryFilter();
        loadInstitutionRate();
    }, []);

    useEffect(() => {
        loadDatatableInfo()
    }, [categorieProduitSelected]);

    const fakeData = [
        {
            id: "1", produit: "Epargne Junior", taux: "Microred", categorieProduit: "Crédit de trésorie"
        },
        {
            id: "2", produit: "Epargne Scolaire", taux: "Microgreen", categorieProduit: "Crédit épargne"
        },
        {
            id: "3", produit: "Epargne Retraite", taux: "Microblack", categorieProduit: "Crédit de solidarité"
        }
    ]

    const loadCategoryFilter = async () => {
        const categoryFilter_response = await getCategoryProductFilterList();
        if (categoryFilter_response.response && categoryFilter_response.response.status !== 200) {
            console.log(categoryFilter_response.response?.data)
        } else {
            console.log("ok", categoryFilter_response.data)
            const institutionsCategories = categoryFilter_response.data?.map(value => ({
                value: value.id,
                label: value.libelle,
            }))
            setCategoriesProduit(institutionsCategories)
        }
    }


    const loadDatatableInfo = async () => {
        const data_response = await getInstitutionDetails(id, categorieProduitSelected?.value);
        if (data_response.response && data_response.response.status !== 200) {
            console.log(data_response.response?.data)
        } else {
            console.log("ok", data_response.data)
            setDisplayLoader(false)
            setData(data_response.data)

        }
    }


    const loadInstitutionRate = async () => {
        const rate_response = await getInstitutionRate(id);
        if (rate_response.response && rate_response.response.status !== 200) {
            console.log(rate_response.response?.data)
        } else {
            console.log("ok", rate_response.data)
            setInstitution(rate_response?.data?.institution)
            let rateLabel = Object.keys(rate_response?.data?.taux);
            let rateValue = Object.values(rate_response?.data?.taux);
            let rates = [];
            console.log("keys : ", rateLabel[0])
            console.log("values : ", rateValue[0])
            rateLabel?.map((index, item) => {
                console.log(item)
                rates.push({ label: index, value: parseFloat(rateValue[item]).toFixed(2) });
            }
            )

            setRate(rates)
            setDisplayLoader(false)

        }
    }

    useEffect(() => {

        console.log(rate)
    }, [rate]);


    const handleChangeEntry = (key, e) => {
        if (key == "etablissement") {
        }
        if (key == "product-category") {
            setCategorieProduitSelected({ value: e.value, label: e.label })
        }

    }

    function dataBox(rate, label) {
        return <div className="data-box p-2">
            <p className=" data-box-rate">{rate} <span className="data-box-rate-percentage"> %</span></p>
            <p className=" data-box-label">{label}</p>
        </div>
    }

    const customStyles = {
        control: (base, state) => ({
            ...base,
            color: "black",
            padding: "0px",
            borderColor: state.isFocused ? "#454655" : "#cccccc",
            boxShadow: state.isFocused ? null : null,

        })
    };
    return (
        <div id="institution">
            {displayLoader == false ?
                <Fragment>
                    <Header logo={institution.logo} bannerImg={bannerImg} title={institution?.libelle} telephone={institution?.telephone} email={institution?.email} />
                    <div className="widget widget-content widget-content-area p-3 my-5 w-90 mx-auto">
                        <p>
                            <h5 className="text-left" style={{ textAlign: 'left' }}><ImMakeGroup className="pb-1 mr-2" />Taux Moyens par catégorie</h5>
                        </p>
                        <hr />
                        <div className="d-flex justify-content-around flex-wrap">
                            {rate.length != 0 ? rate.map(item =>
                                dataBox(item.value, item.label)
                            ) : <h3>Aucune donnée</h3>}
                        </div>
                    </div>
                    <div className="widget widget-content widget-content-area p-3 mb-3 w-90 mx-auto">
                        <h5 className="text-left" style={{ textAlign: 'left' }}> <FiFilter className="pb-1 mr-1" /> Filtres</h5>
                        <hr />
                        <div className="row ">
                            <div className="col-6 col-xs-12 mx-auto">
                                <p className='t-primary-color'>Catégorie Produits</p>
                                <Select
                                    onChange={(e) => handleChangeEntry("product-category", e)}
                                    placeholder=""
                                    classNamePrefix="select"
                                    value={categorieProduitSelected}
                                    isDisabled={false}
                                    isLoading={false}
                                    isClearable={true}
                                    isRtl={false}
                                    isSearchable={true}
                                    name="institution-category"
                                    options={categoriesProduit}
                                    styles={customStyles}
                                // className={"w-50"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="widget widget-content widget-content-area  pb-3 my-5 w-90 mx-auto">
                        <h5 className="text-left p-2" style={{ textAlign: 'left' }}> <FaClipboardList className="pb-1 mr-2" />Liste des produits</h5>
                        <hr />
                        <p style={{ textAlign: 'left' }} className="suivi-taux-total-number text-gray text-left pl-3">{data?.length == undefined ? `0 élément` : (data?.length <= 1 ? `${data?.length} élément` : `${data?.length} éléments`)}</p>
                        {data.length != undefined && data?.length != 0 ?
                            <CustomDatatable columns={tableColumns}
                                data={data}
                            /> : <h1 className="py-3">Aucun résultat</h1>}

                    </div>
                </Fragment> : <div style={{ marginBottom: "-10%" }}>
                    <Loader />
                </div>
            }
        </div>
    )
}

export default Institution